<template>
  <div class="detail" style="transform: translateY(70px);width: 100%" v-html="html"><!--  v-html="html"-->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/bd7886220bae4068ae5b65c39dd75429"
               alt="奖项">
        </div>
        <div class="swiper-slide">
          <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/0e6aced06efd400ebcceaedf3e1bd0f1"
               alt="奖项">
        </div>
        <div class="swiper-slide">
          <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/b6790310ed1f4e488502f0d07feaed00"
               alt="奖项">
        </div>
        <div class="swiper-slide">
          <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/7040488afdde40a9a17b56e2f48b2059"
               alt="奖项">
        </div>
      </div>
      <div class="preview"></div>
    </div>
    <div class="message_three">
      <p class="p_logo" style="font-size: 30px !important; line-height: 10mm !important;">

      </p>
      <div class="logos log_btn" style="width: 100%;height: auto">

        <p class="p_color"
           style="font-size: 15px !important;
            line-height: 8mm !important;">
          项目名称：老年健康一体机<br/>
          合作企业：南京宽乐健康产业有限公司<br/>
          项目时间：2021年4月<br/>
          合作内容：工业设计＋结构设计<br/>
        </p>

        <p class="p_color" style="font-size: 15px !important; line-height: 8mm !important;">
          项目介绍:
        </p>

        <p>
          &nbsp;
        </p>

        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/bd7886220bae4068ae5b65c39dd75429"
             alt="奖项">
        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/0e6aced06efd400ebcceaedf3e1bd0f1"
             alt="奖项">
        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/b6790310ed1f4e488502f0d07feaed00"
             alt="奖项">
        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/b6f5cc4257314a3da574d36ad6258f68"
             alt="奖项">
        <img style="width: 100%;height: auto" src="http://qiniu.shujunjun.club/7040488afdde40a9a17b56e2f48b2059"
             alt="奖项">
        <br/>
        <br/>
        <p class="p_color"
           style="font-size: 10px !important;
            line-height: 8mm !important;">
          copyright © oaim design all rights reserved.
          <br/>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Swiper from "swiper4/js/swiper";
import 'swiper4/css/swiper.css';
import $ from "jquery";

export default {
  name: "Detail",
  mounted() {
    // 设置语言
    // this.GLOBFUNC.chanLan()
    this.getCaseId();
    this.swiperMethod();
  },
  data() {
    return {
      html: ''
    }
  },
  methods: {
    getCaseId() {
      let caseId = this.$route.query.key
      let param = {caseId: caseId}
      let that = this
      axios({
        method: 'get',
        url: '/back/caseDetail/caseDetail',
        params: param
      }).then(res => {
        that.html = res.data.data.message
      })
    },
    swiperMethod() {
      let ms = new Swiper('.swiper-container', {
        autoplay: true,
        spaceBetween: 10,
        thumbs: {
          swiper: {
            el: '.swiper-container',
            spaceBetween: 10,
            slidesPerView: 4,
            watchSlidesVisibility: true,
          },
        }
      });
    }
  }
}
</script>

<style>
.c-body > img {
  width: 100%;
  height: 100%;
}

.message_one {
  margin-left: 16.5%;
  margin-right: 16.5%;
  margin-top: 22mm;
}

.message_one > p {
  /*white-space: pre-wrap;*/
  text-align: left;
  line-height: 12mm;
  font-size: 15px;
}

.message_two {
  margin: 0 16.5%;
}

.logos > p:first-of-type {
  margin-top: 11.5mm;
  margin-bottom: 10mm;
  font-size: 15px;
}

.message_two > p:first-of-type {
  /*white-space: pre-wrap;*/
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  margin-top: 22mm;
  margin-bottom: 11.5mm;
  /*background-color: rgb(213,213,213)*/
}

.message_two > p:last-of-type {
  /*border: 1px solid red;*/
  text-align: left;
  /*white-space: pre-wrap;*/
  font-size: 15px;
  line-height: 12mm;
  /*margin-bottom: 35mm;*/
}

.logos > img {
  width: 100%;
  height: auto;
  /*border: 1px solid green;*/
}

.logos > p {
  text-align: left;
}

.message_three {
  margin: 200px auto; /*30mm 16.5% 0 16.5%*/
  line-height: 12mm;
  /*border: 1px solid blue;*/
  max-width: 1052px;
  /*transform: translateY(20mm);*/
}
@media (min-width: 1250px) {
  .message_three {
    margin: 30mm auto !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 1052px;
    /*margin-top: 35mm;*/
  }
}

@media (min-width: 1100px) and (max-width: 1249px) {
  .message_three {
    margin: 30mm auto !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 954px;
    /*margin-top: 35mm;*/
  }
}

@media (min-width: 510px) and (max-width: 1099px) {
  .message_three {
    margin: 30mm 10% 0 10% !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 954px;
    /*margin-top: 35mm;*/
  }
}

.message_three > p {
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  /*background-color: rgb(213,213,213)*/
}

.p_color {
  color: rgb(80, 80, 80);
  text-align: left;
  word-break: break-word;
}

.p_logo {
  color: rgb(16, 16, 16);
}

.log_btn {
  margin-bottom: 140px;
}
</style>



// WEBPACK FOOTER //
// src/views/detail/Detail.vue